export class UploadExcelForWorkflow {
    static readonly type = '[Workflow] Upload Excel For Workflow';
    constructor(
        public excelFile: File,
        public workflowId: string
    ) {}
}
